<ng-container *ngIf="path">
	<a
		*ngIf="linkEvent"
		class="link-item"
		[routerLink]="path"
		[routerLinkActive]="activeClass"
		[track-event]="linkEvent"
		custom-tracking
		[ngClass]="classes"
		queryParamsHandling="merge"
		[attr.disabled]="disabled"
	>
		<ng-container [ngTemplateOutlet]="menuItemContent"></ng-container>
	</a>
	<a *ngIf="!linkEvent" class="link-item" [routerLink]="path" [routerLinkActive]="activeClass" [ngClass]="classes" queryParamsHandling="merge" [attr.disabled]="disabled">
		<ng-container [ngTemplateOutlet]="menuItemContent"></ng-container>
	</a>
</ng-container>
<ng-container *ngIf="!path">
	<span
		*ngIf="linkEvent"
		class="link-item"
		(click)="onMenuItemClick.emit(event)"
		[track-event]="linkEvent"
		custom-tracking
		[ngClass]="classes"
		queryParamsHandling="merge"
		[attr.disabled]="disabled"
	>
		<ng-container [ngTemplateOutlet]="menuItemContent"></ng-container>
	</span>
	<span *ngIf="!linkEvent" class="link-item" (click)="onMenuItemClick.emit(event)" [ngClass]="classes" queryParamsHandling="merge" [attr.disabled]="disabled">
		<ng-container [ngTemplateOutlet]="menuItemContent"></ng-container>
	</span>
</ng-container>
<ng-template #menuItemContent>
	<dz-icon *ngIf="icon" [type]="icon" class="color-blk-orange margin-right-object-2"></dz-icon>
	<span class="icon-caption dz-text-16-bold dz-text-align-right"> <ng-content></ng-content> </span>
</ng-template>
